module.exports = __webpack_public_path__ + "static/fonts/355CC9_2_0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/355CC9_2_0.ttf
// module id = 151
// module chunks = 0